<template>
  <div class="cart history">
    <DualButton
      :show="showOrderModal"
      :order="currentOrder"
      @email="emailOrder"
      @load="loadOrder"
      @print="printOrder"
    />
    <details>
      <summary @click="rotate(1)">
        <font-awesome-icon icon="caret-right" class="edit blue" id="1" />
        Filter By:
      </summary>
      <section>
        <div class="filter">
          <!-- should one by different style so they dont try chose both? or should this be changed??-->
          <Carousel
            :items="deliveryOptions"
            all
            :style="'arrow'"
            :selected="deliveryOptions[1]"
            title="Delivery Options"
            @select-item="selectFilter"
          />
          <Carousel
            :items="paymentOptions"
            all
            :style="'arrow'"
            title="Payment Options"
            @select-item="selectPaymentFilter"
          />
        </div>
      </section>
    </details>
    <ul class="grid wrapper" id="history" ref="history">
      <HistoryOrder
        :order="order.value"
        @click="
          currentOrder = order.value;
          showOrderModal = !showOrderModal;
        "
        v-bind:key="order"
        v-for="order in allHistory"
      />
      <!-- v-for="order in history" -->
    </ul>
  </div>
</template>

<script>
import DualButton from "@/components/History/DualButton";
import { mapActions, mapGetters } from "vuex";
// import createdMixin from "@/components/_mixins/createdMixin";
import HistoryOrder from "@/components/History/HistoryOrder";
import { Carousel } from "@monolith/components";
//import Datepicker from '@vuepic/vue-datepicker';
//import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: "HistoryColumn",
  // mixins: [createdMixin],
  components: {
    HistoryOrder,
    DualButton,
    Carousel,
    //Datepicker
  },

  data() {
    return {
      currentOrder: null,
      showOrderModal: false,
      chosenFilter: null,
      tableMode: false,
      allHistory: this.$store.getters.history, //start with the full history
      historyFilter: "all", //default filter
      deliveryFilter: "all", //do we need this?
      sortFilter: "latest", //default sort
      deliveryOptions: [
        { name: "All", value: "all", selected: true},
        { name: "Online", value: "online" },
        { name: "Dine-In", value: "dine-in" },
        { name: "Takeaway", value: "takeaway" },
        { name: "Catering", value: "catering" },
      ],
      paymentOptions: [
        { name: "All", value: "all", selected: true},
        { name: "Unpaid", value: "active" },
        { name: "Paid", value: "complete" },
      ],
    };
  },
  mounted() {
    document
      .querySelector("div.parent")
      .addEventListener("scroll", this.debounce(this.onScroll, 300), {
        passive: true,
      });
  },
  beforeUnmount() {
    document.removeEventListener("scroll", this.onScroll);
  },

  methods: {
    rotate(id) {
      document.getElementById(id).classList.toggle("rotated");
    },
    selectFilter(item) {
      this.deliveryFilter = item;
      this.chosenFilter = "delivery";
    },
    selectPaymentFilter(item) {
      this.historyFilter = item;
      this.chosenFilter = "payment";
    },
    filterHistory(filter) {
      // should this work with both of the filters?
      const fullHistory = this.$store.getters.history; //get the fill history from the store
      if (filter === "active") {
        this.historyFilter = filter;
        this.allHistory = this.getHistory.filter((order) => {
          return (
            this.total(order) - this.paid(order) > 0 &&
            order.value.delivery != "online"
          );
        });
      } else if (filter === "complete") {
        this.historyFilter = filter;
        this.allHistory = this.getHistory.filter((order) => {
          return this.total(order) - this.paid(order) <= 0;
        });
      } else if (filter === "all") {
        this.historyFilter = filter;
        this.allHistory = fullHistory;
      }
    },
    filterDelivery(filter) {
      if (filter === "online") {
        this.deliveryFilter = filter;
        this.allHistory = this.getHistory.filter((order) => {
          return order.value.delivery === "online";
        });
      } else if (filter === "dine-in") {
        this.deliveryFilter = filter;
        this.allHistory = this.getHistory.filter((order) => {
          return order.value.delivery === "dine-in";
        });
      } else if (filter === "takeaway") {
        this.deliveryFilter = filter;
        this.allHistory = this.getHistory.filter((order) => {
          return order.value.delivery === "takeaway";
        });
      } else if (filter === "catering") {
        this.deliveryFilter = filter;
        this.allHistory = this.getHistory.filter((order) => {
          return order.value.delivery_option === "future-pickup";
        });
      } else if (filter === "all") {
        this.deliveryFilter = filter;
        this.allHistory = this.getHistory;
      }
    },
    // comes from history order
    total(order) {
      if (order.value.products !== undefined) {
        return order.value.products.reduce((runningTotal, product) => {
          return runningTotal + product.price * product.quantity;
        }, 0);
      } else {
        return 0;
      }
    },
    paid(order) {
      if (order.value.payments !== undefined) {
        return order.value.payments.reduce((runningTotal, payment) => {
          return runningTotal + parseFloat(payment.value);
        }, 0);
      } else {
        return 0;
      }
    },
    onScroll() {
      var history = this.$refs["history"];
      if (history) {
        var marginTopUsers = history.getBoundingClientRect().bottom;
        var innerHeight = window.innerHeight;
        if (innerHeight > Math.abs(marginTopUsers)) {
          this.appendHistory();
          if (this.chosenFilter == "delivery") {
            this.filterDelivery(this.deliveryFilter);
          } else {
            this.filterHistory(this.historyFilter);
          }
        }
      }
    },
    debounce(fn, wait) {
      let timer;
      return function (...args) {
        if (timer) {
          clearTimeout(timer); // clear any pre-existing timer
        }
        const context = this; // get the current context
        timer = setTimeout(() => {
          fn.apply(context, args); // call the function if time expires
        }, wait);
      };
    },
    loadOrder(order) {
      this.$store.dispatch("initialiseCartFromHistory", order);
      this.$emit("showTab", "cart");
    },

    emailOrder(order, to_address) {
      order.email = to_address;
      //let from_address = "no-reply@beamy.nz";
      this.channel.push("email:receipt", order).receive("ok", (reply) => {
        if ("error" in reply) {
          this.$notify({
            text: "Email Failed to Send",
            type: "error",
          });
          return;
        } else if ("reply" in reply) {
          this.$notify({
            text: "Email Sent",
            type: "success",
          });
        }
      });
    },

    printOrder(order) {
      var products;
      var eol = "\r\n";
      let receipt = {};
      const cc = 10; // character count(width of eftpos printer)
      const reducer = (acc, value) => acc + value;
      const padStringQuantity = (name, quantity, number) =>
        name.length > cc
          ? name.substring(0, 19) +
            eol +
            "X" +
            quantity +
            " $" +
            number.toFixed(2) +
            eol
          : name.padEnd(15 - name.length, " ") +
            "X" +
            quantity +
            " $" +
            number.toFixed(2) +
            eol;
      const padString = (name, number) =>
        name.length > 14
          ? name.substring(0, 13) + " $" + number.toFixed(2) + eol
          : name.padEnd(16 - name.length, " ") + " $" + number.toFixed(2) + eol;

      var address = this.siteSettings.address.replace(/,/g, eol);
      var date = new Date(order.created_at).toLocaleString().replace(/,/g, "");
      if (order.payments && order.payments.length !== 0) {
        products = order.products
          .map((item) =>
            padStringQuantity(item.item, item.quantity, item.price)
          )
          .toString()
          .replace(/,/g, "");
        var paid = padString(
          "Paid",
          order.payments.map((item) => item.value).reduce(reducer)
        );
        receipt =
          this.siteSettings.company_name +
          eol +
          address +
          eol +
          eol +
          date +
          eol +
          eol +
          "G.S.T. #" +
          this.siteSettings.gst +
          eol +
          eol +
          products +
          eol +
          paid +
          eol;
      } else {
        var total = padString(
          "Total",
          order.products
            .map((item) => item.quantity * item.price)
            .reduce(reducer)
        );
        products = order.products
          .map((item) =>
            padStringQuantity(item.item, item.quantity, item.price)
          )
          .toString()
          .replace(/,/g, "");
        receipt =
          this.siteSettings.company_name +
          eol +
          address +
          eol +
          eol +
          date +
          eol +
          eol +
          "G.S.T. #" +
          this.siteSettings.gst +
          eol +
          eol +
          products +
          eol +
          total +
          eol;
      }

      receipt +=
        "ID: " +
        order._id.substring(0, 15) +
        eol +
        order._id.substring(16) +
        eol;
      //var receipt_example = "Beam Me Up Bagels\r\n*------------------*\r\n\r\nADULT\t$100.00\r\nGEAR RENTA\t$35.00\r\n\r\nTOTAL $135.00\r\nincl GST $17.61\r\n*------------------*\r\nTHANKS FOR COMING\r\n";
      if (window.Android && window.Android.printReceipt) {
        window.Android.printReceipt(
          receipt,
          this.eftposSettings[0].ip,
          parseInt(this.eftposSettings[0].port)
        );
      }
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.EFTPOSHandler.postMessage({
          action: "printReceipt",
          additionalData: {
            ip: this.eftposSettings[0].ip,
            port: parseInt(this.eftposSettings[0].port),
            receipt: receipt,
          },
        });
      } else {
        //left blank purposefully
      }
    },

    ...mapActions(["appendHistory"]),
  },

  computed: {
    currentCategoryDoc() {
      return this.categories.find((cat) => cat.id === this.currentCategory);
    },
    ...mapGetters({
      history: "history",
      eftposSettings: "eftposSettings",
      siteSettings: "siteSettings",
      localSettings: "localSettings",
      products: "cartProducts",
    }),
    getHistory() {
      return this.history;
    },
  },
  watch: {
    historyFilter: function () {
      this.filterHistory(this.historyFilter);
    },
    deliveryFilter: function () {
      this.filterDelivery(this.deliveryFilter);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.history {
  details {
    margin: 0;
    summary {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .rotated {
        transform: rotate(90deg);
        transition: transform 0.5s;
      }
      .blue {
        color: var(--action-colour);
      }
      .edit {
        margin: 0 0.5rem 0 0;
        font-size: 1.25rem;
        cursor: pointer;
      }
      font-size: 1.25rem;
      box-shadow: var(--box-shadow);
      padding: 1rem;
      border-radius: 5px;
      margin: 0.5rem 1rem;
      cursor: pointer;
      &:active {
        transform: scale(0.99);
      }
    }
  }

  .filter {
    margin: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    max-height: 15rem;
    label {
      margin: 0.5rem;
    }
    select {
      margin: 0 0.5rem;
      padding: 0.5rem;
      border-radius: 0.25rem;
      border: 1px solid #ccc;
      background-color: var(--action-colour);
      color: var(--text-colour);
      font-size: 1rem;
      cursor: pointer;
    }
  }

  h2 {
    margin-top: 0px;
    padding-top: 1rem;
    span:nth-of-type(1) {
      color: #aaa;
    }
    cursor: pointer;
  }

  ul.wrapper {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin: 0.5rem;
    padding: 0.5rem;
    .modifierBox {
      background-color: var(--primary-colour);
      .modifier-total {
        display: block;
        font-weight: bold;
        text-align: right;
      }
      li.lineItem {
        margin-bottom: 1rem !important;

        .lineItemSummary {
          display: flex;
          .lineItemName {
            flex: 1 1;
            display: inline-block;
            text-align: left;
          }
          .lineItemTotal {
            flex: 0 0;
            display: inline-block;
            text-align: right;
          }
        }
      }

      ul.modifiers {
        border-bottom: 1px solid #ccc;
        font-size: 0.8em;
        li {
          list-style-type: none;
          display: flex;
          .submodifier-name {
            flex: 1 1;
            display: inline-block;
          }
          .submodifier-total {
            flex: 0 0;
            display: inline-block;
            text-align: right;
          }
        }

        margin: 0px;
        padding: 0px;
      }
    }
  }
}
</style>
